import React, { useState } from "react";
import { Plus } from "lucide-react";
import { ReactComponent as Undo } from "../../../icons/undo.svg";
import { RuvnlTitle } from "../components";
import Hamburger from "../../../components/Hamburger";
import { TabSwitcher } from "../Raj_Dashboard";
import CreateNewSessionModal from "./Resource/Popup/CreateSessionPopup";
import { useOptimizerNavigation } from "./useOptimizerNavigation";
import { getGNAOptimizerSession } from "../../../Rest_api/DemoRestApi";
export default function RuvitlOptim() {
  const [isModalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { navigateToPage, goToPreviousStage } = useOptimizerNavigation();
  const GotoPreviousStage = async () => {
    setLoading(true);
    await goToPreviousStage(getGNAOptimizerSession);
    setLoading(false);
  };

  // const GotoArchivePage = () => {
  //   navigateToPage("archive");
  // };

  return (
    <>
      <div className="w-full">
        <div className="dashboard-header flex items-center justify-between px-4">
          <div className="flex items-start">
            <Hamburger />
            <div className="ms-5">
              <TabSwitcher />
            </div>
            <div>
              <h5 className="text-[18px] text-[#6F6D7C] ms-5 font-medium">
                GNA-TGNA Optimizer
              </h5>
            </div>
          </div>
          <div className="flex-1 flex justify-center ml-[-388px]">
            <RuvnlTitle />
          </div>
        </div>
        <div className="">
          {" "}
          <div className="h-[calc(-90px+100vh)] p-4">
            <div className="w-full h-full">
              <div className="meritEngine w-full h-full flex flex-col items-center justify-center px-4 rounded-xl relative bg-mod bg-bottom bg-no-repeat bg-cover">
                <div className=" ">
                  <div className="text-center !my-20">
                    <h1 className="text-5xl  font-semibold text-[#F1935C] tracking-wider">
                      GNA-TGNA Allocation Optimizer
                    </h1>

                    {/* <h2 className="text-5xl font-semibold text-[#525062] mt-8 tracking-wider">
                      Instant Merit Order Dispatch:
                    </h2> */}

                    <p className="text-[#525062] font-normal mt-4 text-4xl tracking-wider">
                      Flexible, Cost-Efficient, Reliable
                    </p>

                    <p className="text-[#F1935C] font-semibold mt-6 text-3xl tracking-wide">
                      Powered by{" "}
                      <span className="text-[#F1935C] font-bold">GNA</span>
                      <span className="text-[#6F6D7C]">i</span>
                    </p>

                    {/* Buttons */}
                    <div className="flex gap-10 justify-center !mt-16 flex-wrap">
                      <button
                        onClick={() => setModalOpen(true)}
                        className="flex items-center gap-1 text-lg rounded-2xl px-5 py-3 bg-[#F1935C] shadow-lg text-[#fff] font-medium border border-[#F1935C] hover transition transform hover:scale-105"
                      >
                        <Plus strokeWidth={3} className="w-6 h-6" />
                        <span>Create a New Session</span>
                      </button>
                      <button
                        onClick={GotoPreviousStage}
                        className="flex items-center gap-1 text-lg rounded-2xl px-5 py-3 bg-[#FFF] text-[#F1935C] font-medium border border-[#F1935C] hover transition transform hover:scale-105"
                      >
                        {loading ? (
                          <span>Loading...</span>
                        ) : (
                          <span>Continue to Previous Session</span>
                        )}
                      </button>
                    </div>

                    {/* Archive link */}
                    <div className="flex items-center justify-center mt-8">
                      <button
                        // onClick = {GotoArchivePage}
                        className="flex items-center gap-2 px-7 py-5 text-lg  border-[#34656D] bg-transprent text-[#34656D] font-medium"
                      >
                        <Undo className="w-5 h-5" />
                        Go to Archive
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <CreateNewSessionModal
                isOpen={isModalOpen}
                onClose={() => setModalOpen(false)}
              />
            </div>
          </div>
          <div className="gna-footer-container">
            <div className="grid grid-cols-2 justify-between gap-5 ">
              {/* <p className="gna-footer-text"> </p> */}

              <p className="gna-footer-text col-span-1 text-start">
                Powered by <strong>GNA Energy</strong>
              </p>
              <strong className="gna-footer-text col-span-1 text-end">
                Beta Version
              </strong>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
